const height = "115px";

export const productCardHelper = {
  height,
};
